import { Plus, X } from 'lucide-react';

const fieldClass = "w-full px-2.5 py-1.5 text-sm border border-stone-300 rounded bg-white focus:outline-none focus:border-stone-600 focus:ring-1 focus:ring-stone-600 transition-colors";
const labelClass = "block text-[11px] uppercase tracking-wider text-stone-500 mb-1 font-medium";

export default function ListInput({ label, items, onChange, placeholder = "Add item" }) {
  const update = (i, v) => onChange(items.map((it, idx) => idx === i ? v : it));
  const add = () => onChange([...items, ""]);
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));

  return (
    <div>
      <label className={labelClass}>{label}</label>
      <div className="space-y-1.5">
        {items.map((item, i) => (
          <div key={i} className="flex gap-1.5">
            <input
              className={fieldClass}
              value={item}
              onChange={(e) => update(i, e.target.value)}
              placeholder={placeholder}
            />
            <button
              onClick={() => remove(i)}
              className="px-2 text-stone-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
              aria-label="Remove"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}
        <button
          onClick={add}
          className="text-xs text-stone-600 hover:text-stone-900 flex items-center gap-1 px-2 py-1 rounded hover:bg-stone-100 transition-colors"
        >
          <Plus className="w-3 h-3" /> Add
        </button>
      </div>
    </div>
  );
}
